import { COLORS, TYPOGRAPHY } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

const styleSheet = createStyleSheet({
  container: {
    height: '100%',
  },
  list: {
    maxWidth: 964,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 auto',
    paddingBottom: 100,
  },
  createActivityButton: {
    alignSelf: 'flex-end',
    marginTop: 48,
    marginBottom: 16,
  },
  loader: {
    marginTop: 100,
    height: '100%',
    position: 'relative',
  },

  groupedActivitiesCard: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    borderRadius: 18,

    paddingBottom: 12,
    paddingLeft: 12,
    paddingRight: 12,
  },
  liveGroupedActivitiesCard: {
    backgroundColor: '#D2F1D7',
    marginTop: 68,
    marginBottom: 50,
  },
  upcomingGroupedActivitiesCard: {
    backgroundColor: '#D5E8FF',
    marginBottom: 50,
  },
  groupedActivitiesCardHeader: {
    display: 'flex',
    height: 48,
    lineHeight: 48,
    alignItems: 'center',
    gap: 10,
  },
  groupedActivitiesCardTitle: {
    ...TYPOGRAPHY.H2_SEMIBOLD,
  },
  liveTitleColor: {
    color: COLORS.SUCCESS.DEFAULT,
  },
  upcomingTitleColor: {
    color: COLORS.PRIMARY.HOVER,
  },
  groupedActivitiesCardBody: {
    display: 'flex',
    gap: 10,
    width: '100%',
    flexDirection: 'column',
  },

  otherActivitiesSeparatorContainer: {
    display: 'flex',
    height: 21,
    width: '100%',
    alignItems: 'center',
    gap: 16,
    marginBottom: 20,
  },
  separator: {
    flexGrow: 1,
    height: 2,
    backgroundColor: COLORS.GREY_MEDIUM.DEFAULT,
  },
  otherActivitiesContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    width: '100%',
  },
  formWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  asterisk: {
    color: '#FD4E5A',
  },
});

export default styleSheet;
